
import { defineComponent } from "vue";
import { UserPlus, ArrowLeft, Play, X } from "lucide-vue-next";

import * as api from "@/api/actions";
import PlayerPicture from "@/components/Elements/PlayerPicture.vue";
import ScreenTitle from "@/components/Elements/ScreenTitle.vue";

export default defineComponent({
  components: { PlayerPicture, ScreenTitle, UserPlus, ArrowLeft, Play, X },
  name: "NotStartedGameView",
  inject: ["game"],
  data: () => ({
    creatingPlayerName: "",
    autoCollect: false,
  }),
  computed: {
    gameId(): string {
      return this.game.gameId;
    },
    players(): Array<{ id: number; name: string }> {
      return this.game.players;
    },
    activePlayerId(): number | null {
      return this.game.activePlayerId;
    },
  },
  methods: {
    goBack() {
      this.$router.push({ name: "start" });
    },
    createPlayer() {
      api.addPlayerToGame(this.game.gameId, this.creatingPlayerName);
      this.creatingPlayerName = "";
    },
    removePlayer(playerId: number) {
      api.removePlayerFromGame(this.game.gameId, playerId);
    },
    startGame() {
      api.startGame(this.game.gameId, this.autoCollect);
    },
  },
});
